// extracted by mini-css-extract-plugin
export var clientLogo = "ContactUs-module--clientLogo--6db20";
export var clients = "ContactUs-module--clients--2985b";
export var clientsList = "ContactUs-module--clientsList--9a0f2";
export var column = "ContactUs-module--column--21ef9";
export var container = "ContactUs-module--container--de2df";
export var fadeInAnimation = "ContactUs-module--fadeInAnimation--8975c";
export var form = "ContactUs-module--form--85dd3";
export var mobileTitles = "ContactUs-module--mobileTitles--16ea9";
export var steps = "ContactUs-module--steps--d4c6c";
export var wrapper = "ContactUs-module--wrapper--cc922";